"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vec3 = require("@antv/gl-matrix/lib/gl-matrix/vec3");
exports.default = vec3;
//# sourceMappingURL=vec3.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/matrix-util/lib/vec3.js
// module id = 1059
// module chunks = 37